import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { message, Upload } from 'ant-design-vue';
import { awaitWrap } from '@/common';
import { uploadComplaintImage } from '@/api/wechatComplaint';
import { uploadAuditScreenshot } from '@/api/goodsInfo';
import { isOkResponse } from './useComplaintActions';
const MAX_IMAGE_BYTES = 2 * 1024 * 1024;
const MAX_IMAGE_COUNT = 4;
const MAX_REFUND_SCREENSHOT_COUNT = 3;
const validateImageFile = file => {
  const validExt = /\.(jpg|bmp|png)$/i.test(file.name);
  if (!file.type.includes('image') || !validExt) {
    message.error('请上传 JPG/BMP/PNG 图片');
    return false;
  }
  if (file.size > MAX_IMAGE_BYTES) {
    message.error('单张图片不能超过 2M');
    return false;
  }
  return true;
};
let fileUidSeed = 0;
const nextFileUid = () => `wc-${Date.now()}-${++fileUidSeed}`;
const getUploadMediaId = res => {
  const data = res === null || res === void 0 ? void 0 : res.data;
  if (typeof data === 'string') return data;
  return (data === null || data === void 0 ? void 0 : data.mediaId) || (data === null || data === void 0 ? void 0 : data.media_id) || (data === null || data === void 0 ? void 0 : data.id) || '';
};
export const useComplaintUiState = getComplaintMainId => {
  const tableHeight = ref(`${window.innerHeight - 390}px`);
  const detailOpen = ref(false);
  const replyContent = ref('');
  const replyFiles = ref([]);
  const resending = ref(false);
  const resendText = ref('复送');
  const refundOpen = ref(false);
  const rejectOpen = ref(false);
  const batchOpen = ref(false);
  const batchType = ref('refund');
  const refundAmount = ref(0);
  const refundReason = ref('');
  const rejectReason = ref('');
  const batchRefundMode = ref('full');
  const batchRefundRatio = ref();
  const batchRefundReason = ref('');
  const batchReplyContent = ref('');
  const batchReplyFiles = ref([]);
  const refundScreenshots = ref([]);
  const collectImage = async (file, target) => {
    var _res$data, _res$data2;
    if (!validateImageFile(file)) return;
    if (target.value.length >= MAX_IMAGE_COUNT) {
      message.warning(`最多上传${MAX_IMAGE_COUNT}张图片`);
      return;
    }
    const localUrl = URL.createObjectURL(file);
    const item = reactive({
      uid: nextFileUid(),
      name: file.name,
      status: 'uploading',
      url: localUrl
    });
    target.value.push(item);
    const formData = new FormData();
    const complaintMainId = getComplaintMainId === null || getComplaintMainId === void 0 ? void 0 : getComplaintMainId();
    if (!complaintMainId) {
      item.status = 'error';
      message.error('缺少客诉单 ID，无法上传图片');
      return;
    }
    formData.append('complaintMainId', String(complaintMainId));
    formData.append('file', file);
    const [, res] = await awaitWrap(uploadComplaintImage(formData));
    const mediaId = isOkResponse(res) ? getUploadMediaId(res) : '';
    const remoteUrl = isOkResponse(res) ? (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.url) || (res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.fileUrl) || '' : '';
    if (!mediaId) {
      item.status = 'error';
      message.error('图片上传失败，请重新上传');
      return;
    }
    if (remoteUrl) {
      URL.revokeObjectURL(localUrl);
      item.url = remoteUrl;
    }
    item.response = {
      mediaId
    };
    item.status = 'done';
  };
  const collectRefundScreenshot = async file => {
    var _getComplaintMainId, _res$data3;
    const validExt = /\.(jpe?g|png)$/i.test(file.name);
    if (!file.type.includes('image') || !validExt) {
      message.error('请上传 PNG/JPG 图片');
      return;
    }
    if (file.size > MAX_IMAGE_BYTES) {
      message.error('单张图片不能超过5M');
      return;
    }
    if (refundScreenshots.value.length >= MAX_REFUND_SCREENSHOT_COUNT) {
      message.warning(`最多上传${MAX_REFUND_SCREENSHOT_COUNT}张图片`);
      return;
    }
    const localUrl = URL.createObjectURL(file);
    const item = reactive({
      uid: nextFileUid(),
      name: file.name,
      status: 'uploading',
      url: localUrl
    });
    refundScreenshots.value.push(item);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('businessId', String((_getComplaintMainId = getComplaintMainId === null || getComplaintMainId === void 0 ? void 0 : getComplaintMainId()) !== null && _getComplaintMainId !== void 0 ? _getComplaintMainId : ''));
    formData.append('businessType', 'ORDER_REFUND');
    formData.append('accessAttribute', '1');
    const [err, res] = await awaitWrap(uploadAuditScreenshot(formData));
    if (err || !isOkResponse(res)) {
      item.status = 'error';
      message.error('图片上传失败，请重新上传');
      return;
    }
    URL.revokeObjectURL(localUrl);
    item.url = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.fileUrl;
    item.status = 'done';
  };
  const beforeUploadRefundScreenshot = file => {
    collectRefundScreenshot(file);
    return Upload.LIST_IGNORE;
  };
  const pasteRefundScreenshot = event => {
    var _event$clipboardData;
    Array.from(((_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.files) || []).forEach(file => collectRefundScreenshot(file));
  };
  const revokeRefundScreenshots = () => {
    revokeBlobUrls(refundScreenshots.value);
    refundScreenshots.value = [];
  };
  const removeRefundScreenshot = file => {
    if (typeof (file === null || file === void 0 ? void 0 : file.url) === 'string' && file.url.startsWith('blob:')) URL.revokeObjectURL(file.url);
    refundScreenshots.value = refundScreenshots.value.filter(item => item.uid !== file.uid);
  };
  const beforeUploadReplyImage = file => {
    if (replyFiles.value.length >= MAX_IMAGE_COUNT) {
      message.warning(`最多上传${MAX_IMAGE_COUNT}张图片`);
      return Upload.LIST_IGNORE;
    }
    if (!validateImageFile(file)) return Upload.LIST_IGNORE;
    collectImage(file, replyFiles);
    return Upload.LIST_IGNORE;
  };
  const beforeUploadBatchReplyImage = file => {
    collectImage(file, batchReplyFiles);
    return Upload.LIST_IGNORE;
  };
  const pasteImage = event => {
    var _event$clipboardData2;
    const files = Array.from(((_event$clipboardData2 = event.clipboardData) === null || _event$clipboardData2 === void 0 ? void 0 : _event$clipboardData2.files) || []);
    files.forEach(file => collectImage(file, replyFiles));
  };
  const normalizePastedImageFile = file => {
    if (/\.(jpg|bmp|png)$/i.test(file.name)) return file;
    const ext = file.type.includes('png') ? 'png' : file.type.includes('bmp') ? 'bmp' : 'jpg';
    return new File([file], `paste-${Date.now()}.${ext}`, {
      type: file.type
    });
  };
  const pasteBatchReplyImage = event => {
    var _clipboardData$files;
    const clipboardData = event.clipboardData;
    const files = Array.from(clipboardData !== null && clipboardData !== void 0 && (_clipboardData$files = clipboardData.files) !== null && _clipboardData$files !== void 0 && _clipboardData$files.length ? clipboardData.files : []);
    if (!files.length) {
      Array.from((clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.items) || []).forEach(item => {
        if (item.kind === 'file' && item.type.includes('image')) {
          const file = item.getAsFile();
          if (file) files.push(file);
        }
      });
    }
    if (files.length) event.preventDefault();
    files.forEach(file => collectImage(normalizePastedImageFile(file), batchReplyFiles));
  };
  const revokeBlobUrls = files => {
    files.forEach(item => {
      if (typeof (item === null || item === void 0 ? void 0 : item.url) === 'string' && item.url.startsWith('blob:')) URL.revokeObjectURL(item.url);
    });
  };
  const revokeReplyFiles = () => {
    revokeBlobUrls(replyFiles.value);
    replyFiles.value = [];
  };
  const revokeBatchReplyFiles = () => {
    revokeBlobUrls(batchReplyFiles.value);
    batchReplyFiles.value = [];
  };
  const removeReplyFile = file => {
    if (typeof (file === null || file === void 0 ? void 0 : file.url) === 'string' && file.url.startsWith('blob:')) URL.revokeObjectURL(file.url);
    replyFiles.value = replyFiles.value.filter(item => item.uid !== file.uid);
  };
  const removeBatchReplyFile = file => {
    if (typeof (file === null || file === void 0 ? void 0 : file.url) === 'string' && file.url.startsWith('blob:')) URL.revokeObjectURL(file.url);
    batchReplyFiles.value = batchReplyFiles.value.filter(item => item.uid !== file.uid);
  };
  const resizeTable = () => {
    tableHeight.value = `${window.innerHeight - 390}px`;
  };
  return {
    tableHeight,
    detailOpen,
    replyContent,
    replyFiles,
    resending,
    resendText,
    refundOpen,
    rejectOpen,
    batchOpen,
    batchType,
    refundAmount,
    refundReason,
    rejectReason,
    batchRefundMode,
    batchRefundRatio,
    batchRefundReason,
    batchReplyContent,
    batchReplyFiles,
    refundScreenshots,
    beforeUploadRefundScreenshot,
    pasteRefundScreenshot,
    revokeRefundScreenshots,
    removeRefundScreenshot,
    pasteImage,
    pasteBatchReplyImage,
    revokeReplyFiles,
    revokeBatchReplyFiles,
    removeReplyFile,
    removeBatchReplyFile,
    beforeUploadReplyImage,
    beforeUploadBatchReplyImage,
    resizeTable
  };
};